import React from 'react'
import { connect } from 'react-redux'

const { Component } = React

class HelpButton extends Component {
  render () {
    return (
      <a
        href='help.html'
        target='_tulhelp'
        className='btn btn-default' title='Read documentation'>
        <i className='far fa-question-circle ' />
      </a>
    )
  }
}

const mapStateToProps = function (store, ownProps) {
  return {
  }
}

const mapDispatchToProps = function (dispatch, ownProps) {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HelpButton)
